import Modal from 'components/Layout/Modal';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getSession } from 'store/slices';
import { icons, profilePath, speakerCategoryOptions } from 'utils/constants';
import {
  formatDate,
  formatSessionTime,
  generatePreSignedUrl,
} from 'utils/helpers';
import Loader from 'components/Layout/Loader';
import Card from 'components/Layout/Card';
import './PanelDetailsPoup.scss';

const PanelDetailsPopup = ({ onHide, selectedId }) => {
  const dispatch = useDispatch();
  const [session, setSession] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [speakerPhotos, setSpeakerPhotos] = useState({});
  const [speakerList, setSpeakerList] = useState([]);

  const fetchSessionDetails = async () => {
    const response = await dispatch(getSession(selectedId));
    let data = {};
    if (response?.status === 200) {
      data = response.data;
    }
    setSession(data);
    setSpeakerList(data.speaker_details || []);
    setLoading(false);
  };

  useEffect(() => {
    fetchSessionDetails();
  }, [selectedId]);

  useEffect(() => {
    const fetchAllSpeakerPhotos = async () => {
      const photos = {};
      for (const speaker of speakerList) {
        if (speaker.photo) {
          try {
            const url = await generatePreSignedUrl(speaker?.photo, profilePath);
            photos[speaker.id] = url;
          } catch (error) {
            console.error(
              `Error fetching photo for speaker ${speaker.id}:`,
              error
            );
          }
        }
      }
      setSpeakerPhotos(photos);
    };

    if (speakerList.length > 0) {
      fetchAllSpeakerPhotos();
    }
  }, [speakerList]);

  const {
    session_topic,
    date,
    session_time,
    session_end_time,
    event_city,
    event_county,
    description,
  } = session;

  const categoryName =
    speakerCategoryOptions.find(
      (option) => option.id === session.speaker_category
    )?.name || '';
  return (
    <Modal
      titleBesideClose={categoryName}
      onHide={onHide}
      size="xl"
      isTitleBorder
      isTitleVerticalCenter
    >
      <div className="panel-popup">
        {isLoading ? (
          <Card className="cpt-80 cpb-80">
            <Loader size="md" />
          </Card>
        ) : (
          <>
            <div className="session-detail">
              <div className="session-topic">{session_topic}</div>
              <div className="session-meta d-flex flex-wrap gap-3 align-items-center">
                <div className="d-flex align-items-center">
                  <img src={icons.calendarEvent} alt="Calendar" />
                  <span>{formatDate(date)}</span>
                </div>
                <div className="d-flex align-items-center">
                  <img src={icons.clockEvent} alt="Clock" />
                  <span>
                    {formatSessionTime(session_time, session_end_time)}
                  </span>
                </div>
                <div className="d-flex align-items-center">
                  <img src={icons.locationEvent} alt="Location" />
                  <span>
                    {event_city}, {event_county}
                  </span>
                </div>
              </div>
              <p className="session-description mt-3">{description}</p>
            </div>

            <div className="specker-detail mt-4">
              <div className="title mb-3">All Panel Discussion Members</div>
              <div>
                <div className="row">
                  {speakerList.map((profile, index) => (
                    <div
                      key={index}
                      className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4"
                    >
                      <div className="profile-card h-100">
                        <img
                          src={
                            speakerPhotos[profile.id] ||
                            profile.image ||
                            icons.userImg
                          }
                          alt={profile.name}
                          className="profile-image"
                          loading="lazy"
                        />
                        <div className="profile-content">
                          <h2 className="profile-name">{profile.name}</h2>
                          <p
                            className="profile-role"
                            title={profile.designation}
                          >
                            {profile.designation}
                          </p>
                          <p
                            className="profile-education"
                            title={profile.institution}
                          >
                            {profile.institution}
                          </p>
                          <p
                            className="profile-location"
                            title={profile.country_name}
                          >
                            {profile.country_name}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                  {speakerList.length === 0 && (
                    <div className="col-12 text-center">
                      No panel members found.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default PanelDetailsPopup;
